import { render, staticRenderFns } from "./SearchHistoryEntry.vue?vue&type=template&id=05e22d1b&scoped=true"
import script from "./SearchHistoryEntry.vue?vue&type=script&lang=ts"
export * from "./SearchHistoryEntry.vue?vue&type=script&lang=ts"
import style0 from "./SearchHistoryEntry.vue?vue&type=style&index=0&id=05e22d1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e22d1b",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/components/search/search.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fsearch%2FSearchHistoryEntry.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports